export { LoginGuardGuard } from './guards/login-guard.guard';
export { UsuarioService } from './usuario/usuario.service';
// export { SettingsService } from './settings/settings.service';
export { SharedService } from './shared/shared.service';
export { SidebarService } from './shared/sidebar.service';
export { PerfilService } from './perfil/perfil.service';
export { AffiliateControllService } from './affiliateControll/affiliate-controll.service';
